import type { RoadState } from '@goodtime/shared';

/** A Royal Road trail square, parsed from its label (`start`, `run`,
 *  `gift`, `fs:3`, `coins:50`, `gems:1`). The gift square opens one of the
 *  Sweet Trail's bonus games mid-lap. */
export interface RoadSquare {
  kind: 'start' | 'run' | 'gift' | 'fs' | 'coins' | 'gems';
  amount: number;
}

export function parseSquare(label: string): RoadSquare {
  if (label === 'start' || label === 'run' || label === 'gift') return { kind: label, amount: 0 };
  const [kind, amount] = label.split(':');
  if ((kind === 'fs' || kind === 'coins' || kind === 'gems') && amount !== undefined) {
    const n = Number(amount);
    if (Number.isFinite(n)) return { kind, amount: n };
  }
  throw new Error(`Unknown trail square: ${label}`);
}

/**
 * Which slice of the trail to show when only `size` squares fit: the token
 * stays one square in from the left so the next squares are always visible,
 * clamped to the ends. Returns [start, end) indices.
 */
export function trailWindow(total: number, position: number, size: number): { start: number; end: number } {
  if (size >= total) return { start: 0, end: total };
  const start = Math.max(0, Math.min(position - 1, total - size));
  return { start, end: start + size };
}

/**
 * The coins the trail's squares paid on the spin that produced `road`. The
 * server has already put them in the spin's wallet, so the scene holds them
 * back from the coin counter until they have flown into it.
 */
export function trailSquareCoins(road: Pick<RoadState, 'trail'> | null | undefined): number {
  return road?.trail.steps.reduce((sum, step) => sum + Math.max(0, step.coins), 0) ?? 0;
}
